import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AgentDetail from './AgentDetail';
import * as agentActions from './../../../../../actions/agentAction';

const mapStateToProps = state => {
    return {
        agentState: state.agentReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAgentDetail: (id) => dispatch(agentActions.getAgentDetail(id)),
        setAgentDetail: (agent) => dispatch(agentActions.setAgentDetail(agent)),
        updateAgentDetail: (agent) => dispatch(agentActions.updateAgentDetail(agent)),
        createAgentDetail: (agent) => dispatch(agentActions.createAgentDetail(agent))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AgentDetail));
